import { render, staticRenderFns } from "./FrrFooter.vue?vue&type=template&id=03b34044&scoped=true&"
import script from "./FrrFooter.vue?vue&type=script&lang=js&"
export * from "./FrrFooter.vue?vue&type=script&lang=js&"
import style0 from "./FrrFooter.sass?vue&type=style&index=0&id=03b34044&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b34044",
  null
  
)

export default component.exports